import React from "react";
import { Link } from "react-router-dom";
import { IconType } from "../../../assets/IconType";

export interface ReportBlockConfig {
	heading: string;
	Icon: IconType;
	link?: string;
	links?: {
		text: string;
		section?: string;
	}[];
	children?: React.ReactNode;
}

export interface ReportBlockProps {
	block: ReportBlockConfig;
	className?: string;
	courseId?: number;
}

export function ReportBlock(props: ReportBlockProps) {
	const config = props.block;
	const { Icon } = config;

	// Build the link URL with courseId if provided, especially for admin report usage
	const buildLink = (baseLink: string) => {
		if (props.courseId) {
			return `${baseLink}?courseId=${props.courseId}`;
		}
		return baseLink;
	};

	return (
		<div className={`flex w-full md:min-h-32 pb-4 border-b-2 ${props.className}`}>
			<div>
				{config.link ? (
					<Link to={buildLink(config.link)} className="cursor-pointer">
						<Icon className="h-20 text-primary-700" />
					</Link>
				) : (
					<Icon className="h-20 text-primary-700" />
				)}
			</div>
			<div className="pl-4 pt-1">
				<h2>{config.heading}</h2>
				{config.link && config.links && (
					<ul className="pt-1">
						{config.links.map((link, index) => (
							<li key={index}>
								<Link
									to={buildLink(config.link!)}
									className="cursor-pointer"
									state={link.section ? { section: link.section } : {}}>
									{link.text}
								</Link>
							</li>
						))}
					</ul>
				)}
				{config.children}
			</div>
		</div>
	);
}
